import { takeEvery, put, call, delay, takeLatest } from "redux-saga/effects";
import {
  fetchNewsCateApi,
  fetchProjectCateApi,
  fetchSliderApi,
  fetchProjectByIdApi,
  fetchNewsApi,
  fetchAllProjectApi,
  fetchNewsByIdApi,
  fetchNewsContentApi,
  fetchAboutUsApi,
  fetchSharedListApi,
  fetchGeneralContentApi,
  saveContactApi, 
  fetchDetailSharedApi,
  fetchSearchApi
} from "../apis/general";
import {
  showLoading,
  hideLoading,
  fetchNewsCateSuccess,
  fetchNewsCateFailed,
  fetchProjectCateFailed,
  fetchProjectCateSuccess,
  fetchSliderSuccess,
  fetchSliderFailed,
  fetchProjectByIdSuccess,
  fetchProjectByIdFailed,
  fetchNewsSuccess,
  fetchNewsFailed,
  fetchAllProjectSuccess,
  fetchAllProjectFailed,
  fetchNewsByIdSuccess,
  fetchNewsByIdFailed,
  fetchNewsContentSuccess,
  fetchNewsContentFailed,
  fetchAboutUsSuccess,
  fetchAboutUsFailed,
  fetchSharedListSuccess,
  fetchSharedListFailed,
  fetchGeneralContentSuccess,
  fetchGeneralContentFail,
  // saveContactSuccess,
  // saveContactFail, 
  fetchSharedDetailSuccessAction, 
  fetchSharedDetailFailedAction,
  fetchSearchSuccessAction,
  fetchSearchFailedAction
} from "../actions/general";
import * as generalConstants from "../constants/event";
import {successToast, errorToast} from '../helpers/AlertHelper'

function* fetchProjectCateSaga() {
  yield put(showLoading());

  try {
    const res = yield call(fetchProjectCateApi);
    yield put(fetchProjectCateSuccess(res.data.data));
    yield put(hideLoading());
  } catch (error) {
    yield put(hideLoading());
    yield put(fetchProjectCateFailed(error));
  }
}

function* fetchNewsCateSaga() {
  yield put(showLoading());

  try {
    const res = yield call(fetchNewsCateApi);

    yield put(fetchNewsCateSuccess(res.data.data));
    yield put(hideLoading());
  } catch (error) {
    yield put(hideLoading());
    yield put(fetchNewsCateFailed(error));
  }
}

function* fetchSliderSaga() {
  yield put(showLoading());

  try {
    const res = yield call(fetchSliderApi);

    yield put(fetchSliderSuccess(res.data.data));
    yield put(hideLoading());
  } catch (error) {
    yield put(hideLoading());
    yield put(fetchSliderFailed(error));
  }
}

function* fetchProjectByIdSaga({ payload }) {
  const { id, page } = payload.params;

  yield put(showLoading());

  try {
    const res = yield call(fetchProjectByIdApi, id, page);
    yield delay(100);
    yield put(fetchProjectByIdSuccess(res.data));
    yield put(hideLoading());
  } catch (error) {
    yield put(hideLoading());
    yield put(fetchProjectByIdFailed(error));
  }
}

function* fetchAllProjectSaga({ payload }) {
  const { page } = payload.params;

  yield put(showLoading());

  try {
    const res = yield call(fetchAllProjectApi, page);
    yield delay(100);
    yield put(fetchAllProjectSuccess(res.data));
    yield put(hideLoading());
  } catch (error) {
    yield put(hideLoading());
    yield put(fetchAllProjectFailed(error));
  }
}

function* fetchNewsSaga({ payload }) {
  yield put(showLoading());
  const { page } = payload.params;

  try {
    const res = yield call(fetchNewsApi, page);

    yield put(fetchNewsSuccess(res.data));
    yield delay(100);
    yield put(hideLoading());
  } catch (error) {
    yield put(hideLoading());
    yield put(fetchNewsFailed(error));
  }
}

function* fetchNewsByIdSaga({ payload }) {
  const { id, page } = payload.params;

  yield put(showLoading());

  try {
    const res = yield call(fetchNewsByIdApi, id, page);
    yield delay(100);
    yield put(fetchNewsByIdSuccess(res.data));
    yield put(hideLoading());
  } catch (error) {
    yield put(hideLoading());
    yield put(fetchNewsByIdFailed(error));
  }
}

function* fetchNewsContentSaga({ payload }) {
  yield put(showLoading());

  try {
    const res = yield call(fetchNewsContentApi, payload.alias);

    yield delay(100);
    yield put(fetchNewsContentSuccess(res.data));
    yield put(hideLoading());
  } catch (error) {
    yield put(hideLoading());
    yield put(fetchNewsContentFailed(error));
  }
}

// ---------Hien code----------------------
function* fetchAboutUsSaga(){
  yield put(showLoading());
  try{
    const res = yield call(fetchAboutUsApi);

    yield delay(100);
    yield put(fetchAboutUsSuccess(res.data));
    yield put(hideLoading());
  }catch (error) {
    yield put(hideLoading());
    yield put(fetchAboutUsFailed(error));
  }
}

function* fetchSharedListSaga(){
  yield put(showLoading());
  try{
    const res = yield call(fetchSharedListApi);

    yield put(fetchSharedListSuccess(res.data));
    yield put(hideLoading());
  }catch(error){
    yield put(hideLoading());
    yield put(fetchSharedListFailed(error));
  }
}

function* fetchGeneralContentSaga(){
  yield put(showLoading());
  try {
    const res = yield call(fetchGeneralContentApi);
    
    yield put(fetchGeneralContentSuccess(res.data));
    yield put(hideLoading());
  }catch(error){
    yield put(hideLoading());
    yield put(fetchGeneralContentFail())
  }
}

function* saveContactSaga({payload}){
  yield put(showLoading());
  try {
    const res = yield call(saveContactApi, payload.params);
    if (res.data.message) {
      successToast("Liên hệ thành công", 'top-center')
    }
  } catch (err) {
    errorToast("Liên hệ không thành công", 'danger')
  }
}

function* fetchDetailSharedSaga({payload}){
  yield put(showLoading());
  try{
    const res = yield call(fetchDetailSharedApi, payload.alias);
    yield put(fetchSharedDetailSuccessAction(res.data));
    yield put(hideLoading());
  }catch(err){
    yield put(hideLoading());
    yield put(fetchSharedDetailFailedAction());
  }
}

function* fetchSearchSaga({payload}){
  yield put(showLoading());
  try{
    const res = yield call(fetchSearchApi, payload.alias);
    yield put(fetchSearchSuccessAction(res.data));
    yield put(hideLoading());
  }catch(err){
    yield put(hideLoading());
    yield put(fetchSearchFailedAction(err));
  }
}

export default function* generalWatcher() {
  yield takeEvery(generalConstants.FETCH_PROJECT_CATE, fetchProjectCateSaga);
  yield takeEvery(generalConstants.FETCH_NEWS_CATE, fetchNewsCateSaga);
  yield takeEvery(generalConstants.FETCH_SLIDER, fetchSliderSaga);
  yield takeEvery(generalConstants.FETCH_PROJECT_BY_ID, fetchProjectByIdSaga);
  yield takeEvery(generalConstants.FETCH_ALL_PROJECT, fetchAllProjectSaga);
  yield takeEvery(generalConstants.FETCH_NEWS, fetchNewsSaga);
  yield takeEvery(generalConstants.FETCH_NEWS_BY_ID, fetchNewsByIdSaga);
  yield takeEvery(generalConstants.FETCH_NEWS_CONTENT, fetchNewsContentSaga);
  yield takeEvery(generalConstants.FETCH_ABOUT_US_CONTENT, fetchAboutUsSaga);
  yield takeEvery(generalConstants.FETCH_SHARED_LIST, fetchSharedListSaga);
  yield takeLatest(generalConstants.FETCH_GENERAL_CONTENT, fetchGeneralContentSaga);
  yield takeLatest(generalConstants.SAVE_CONTACT, saveContactSaga);

  yield takeLatest(generalConstants.FETCH_DETAIL_SHARED, fetchDetailSharedSaga);
  yield takeLatest(generalConstants.FETCH_SEARCH, fetchSearchSaga);
}
